import Vue from 'vue'
import App from './App.vue'
import 'url-search-params-polyfill'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'

import router from './router/index'
import store from './store/index'
import './element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'

import '@/assets/fonts/iconfont.css'
import '@/assets/fonts/iconfont.js'
import '@/assets/element-ui-icon/element-icons.css'
import '@/icons'
import './env'

// todo 历史原因 上架irs平台路由模式切换为hash模式后，外部访问如果有传参，统一拼接到hash值后面
if (window.location.search) {
  const searchStr = window.location.search
  const url = window.location.href.replace(searchStr, '') + searchStr
  history.replaceState({}, '', url)
}

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: process.env.NODE_ENV === 'production'
//       ? 'http://33fb1446e92245a6bc9098e4f40c8bb5@47.111.31.232:9090/5'
//       : 'http://c2ee3f95bacf403daeffa43fa127e41d@47.111.31.232:9090/4',
//     integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
//   })
// }

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
